// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-cold-weather-icing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-cold-weather-icing/fuel-cold-weather-icing.js';

mount([g0]);
